import AbstractRuleSpecification from 'kaspi.frontend/src/modules/ruleSpecification/AbstractRuleSpecification'

export default class IsAvailablePickContact extends AbstractRuleSpecification {
  constructor () {
    super()

    this._reasonNotSatisfied = 'Функция чтения номера из контакта не доступна!'
  }

  _executeCheckIsSatisfiedBy (mobapp) {
    return mobapp && Object.prototype.hasOwnProperty.call(mobapp, 'pickContact')
  }
}
